import type { Point } from "./game/geometry";
import type { NavigationState } from "./game/navigation-types";
import { navigationDistance } from "./navigation-ui";
import { pressHandlers } from "./press-handlers";

export function FlightNavigation({
  navigation,
  pilot,
  onCancel,
}: {
  navigation: NavigationState;
  pilot: Point;
  onCancel: () => void;
}) {
  if (navigation.status === "idle") return null;
  const active =
    navigation.status === "planning" || navigation.status === "flying";
  const distance = navigationDistance(navigation, pilot);
  return (
    <section
      className={`flight-navigation navigation-${navigation.status}`}
      aria-label="Автопилот"
    >
      <div className="flight-navigation-copy">
        <span
          className="flight-navigation-status"
          role="status"
          aria-live="polite"
        >
          {navigation.status === "planning"
            ? "ПРОКЛАДКА КУРСА"
            : navigation.status === "flying"
              ? "АВТОПИЛОТ"
              : navigation.status === "arrived"
                ? "ТОЧКА ДОСТИГНУТА"
                : "КУРС НЕДОСТУПЕН"}
        </span>
        {navigation.status === "flying" && distance !== null && (
          <b className="flight-navigation-distance">
            ДО ТОЧКИ {distance.toLocaleString("ru-RU")} м
          </b>
        )}
        {navigation.status === "blocked" && <small>Выбери другую точку</small>}
      </div>
      <button
        type="button"
        className="flight-navigation-cancel"
        aria-label={
          active ? "Отменить автопилот" : "Закрыть сообщение автопилота"
        }
        {...pressHandlers(onCancel)}
      >
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="m7 7 10 10M17 7 7 17" />
        </svg>
      </button>
    </section>
  );
}
